import 'babel-polyfill';
import ElementUI, { Message } from 'element-ui';
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css';
import VueLazyload from 'vue-lazyload';
import axios from './api/index';
import App from './App.vue';
import './assets/fonts/iconfont';
import './assets/fonts/iconfont.css';
import Utils from './assets/utils/index';
import './assets/utils/prototype';
import getMsg from './components/ukey/errorCode';
import directives from './directive/index';
import * as Filters from './filters/index';
import { router, initRouter } from './router';
import store from './store';
import './theme/index.css';
import _ from 'lodash';
import { getDeviceType, getIsWeChat } from '../public/js/public'; // 引用JavaScript文件中的方法



const configApi = window.API;

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(directives);

Vue.prototype.viewToken = '';
Vue.prototype.axios = axios;
Vue.prototype.Utils = Utils;
Vue.prototype.configApi = configApi;
Vue.prototype.loading = null;
Vue.prototype.getUkeyError = getMsg;

// 全局message配置
Vue.prototype.$message = function (options: any) {
    let defaultOption = {
        duration: 5000,
        customClass: 'my-message'
    };
    let config = Object.assign(defaultOption, options);
    Message(config);
};
Vue.prototype.$message.error = function (message: any) {
    let defaultOption = {
        duration: 5000,
        customClass: 'my-message'
    };
    let config = Object.assign(defaultOption, { message });
    Message.error(config);
};

Vue.prototype.$message.warning = function (message: any) {
    let defaultOption = {
        duration: 5000,
        customClass: 'my-message'
    };
    let config = Object.assign(defaultOption, { message });
    Message.warning(config);
};

Vue.prototype.$message.info = function (message: any) {
    let defaultOption = {
        duration: 5000,
        customClass: 'my-message'
    };
    let config = Object.assign(defaultOption, { message });
    Message.info(config);
};

Vue.prototype.$message.success = function (message: any) {
    let defaultOption = {
        duration: 5000,
        customClass: 'my-message'
    };
    let config = Object.assign(defaultOption, { message });
    Message.success(config);
};

Vue.use(VueLazyload, {
    throttleWait: 2000
});

// 全局过滤器
Object.keys(Filters).forEach(key => {
    Vue.filter(key, Filters[key]);
});

Vue.prototype.jumpToSuccessPage = function (successPage: any, preview = false) {
    const deviceType = getDeviceType();
    const isWeChat = getIsWeChat();
    console.log('是否是iOS：', deviceType)
    console.log('是否是weChat：', isWeChat)

    if (deviceType === 'ios' || isWeChat) {
        window.location.href = successPage;
    } else {
        const method = preview ? '_blank' : '_self';
        _.delay(() => window.open(successPage, method), 100);
    }
};

async function initApplication() {
    const { data } = await axios
        .get('/qys/webapp/basePath')
        .catch(() => '') as any; // 在运行时初始化应用的基路径

    console.log('BASE_APP_PATH:', data.result);
    (window as any).BASE_APP_PATH = data.result; // 运行时window全局变量，供Vue组件、js模块使用
    Vue.prototype.BASE_APP_PATH = data.result; // 挂载到原型链，供Vue template中使用
    initRouter(data.result);

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}

initApplication();

